import { Injectable } from '@angular/core';
import { API_URL } from '../../../../../services/config';
import { getQueryStringFromObject } from '../../../../../common/utils';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { LoadIdentifier } from '../../../shipment-load/models';
import { ShipmentLoadEndpoint } from '../../constants/shipment-load-endpoint';
import { Observable } from 'rxjs';
import { ShipmentLoadMapData } from '../../models/shipment-load-tracking-map.model';

@Injectable({
  providedIn: 'root',
})
export class ShipmentLoadTrackingMapService {
  constructor(private http: WrapperHttpService) {}

  getShipmentLoadTrackingMapData(loadIdentifier: LoadIdentifier): Observable<ShipmentLoadMapData> {
    return this.http
      .withLoading()
      .get<ShipmentLoadMapData>(
        `${API_URL}${ShipmentLoadEndpoint.Base}${ShipmentLoadEndpoint.Loads}${
          ShipmentLoadEndpoint.Map
        }?${getQueryStringFromObject(loadIdentifier)}`,
      );
  }
}
